module.exports = __webpack_public_path__ + "img/ronda-marker_ro.28cf18bd.png";